import { Clock, Award, BookUser, Zap } from "lucide-react";

const STATS = [
  { icon: Clock, big: "<2 min", small: "average time per estimate" },
  { icon: Award, big: "28 yrs", small: "in HVAC — built by Scott Herberg" },
  { icon: BookUser, big: "1-10", small: "techs per company" },
  { icon: Zap, big: "0", small: "typing — AI fills the line items" },
];

export const StatsBar = () => (
  <section className="border-y border-slate-200 bg-slate-50">
    <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-12 sm:px-6 lg:grid-cols-4 lg:px-8">
      {STATS.map((s) => (
        <div key={s.small} className="text-center">
          <s.icon className="mx-auto h-6 w-6 text-indigo-500" strokeWidth={2.5} />
          <p className="mt-2 font-heading text-3xl font-black text-slate-900">{s.big}</p>
          <p className="mt-1 text-sm text-slate-500">{s.small}</p>
        </div>
      ))}
    </div>
  </section>
);
